export default __webpack_public_path__ + "static/media/goorder.e59cc040.png";